export const ENTRY_RENDER_TYPE = {
  DEFAULT: 'default',
  GRID: 'grid',
  LIST: 'list',
  VIDEO: 'video',
  VIDEOS: 'videos',
  VIDEOS_GRID: 'videos-grid',
  LINKS_LIST: 'links-list',
  AD: 'ad',
  HTML: 'html',
  MODULE: 'module',
  CARD: 'card',
};

export const ENTRY_ID = {
  ARTICLES: 'articles',
  HTML: 'html',
  RATINGS: 'ratings',
};

export const ENTRY_SHARED_ID = {
  RESEARCH_SUBNAV: 'research-subnav',
  CALCULATORS: 'calculators',
  EDITORIAL_HIGH_IMPACT: 'editorial-high-impact',
  FAQ: 'faq',
  PHOTO: 'photo',
};
